/**
 * Pollutant release media (environmental compartments) with Norwegian names.
 *
 * Based on the E-PRTR regulation (EC) No 166/2006 and the EU Industrial
 * Emissions Directive (IED) 2010/75/EU, which define three environmental
 * media to which pollutant releases are reported.
 */

/** Medium codes mapped to Norwegian names. */
export const pollutantMediaNb: Record<string, string> = {
  luft: "Luft",
  vann: "Vann",
  jord: "Jord",
}

/** Sorted array of { code, name } for use in dropdowns. */
export const pollutantMediaOptionsNb: Array<{ code: string; name: string }> = Object.entries(pollutantMediaNb)
  .map(([code, name]) => ({ code, name }))
  .sort((a, b) => a.name.localeCompare(b.name, "nb"))
